import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import * as Constants from '@emi/shared/constants';
import { ProgressBarHandler } from './progress-bar.handler';

@Component({
  selector: 'via-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {

  @Input()
  public ariaLabel = 'Current progress in the configure extraction process';

  @Input()
  public currentStep: number;

  @Input()
  public complete: boolean;
  
  public steps = [
    {
      number: 1,
      title: ''
    },
    {
      number: 2,
      title: 'Configure data'
    },
    {
      number: 3,
      title: 'Save and extract'
    }
  ];

  public highlightNextStep: boolean;

  constructor(private progressBarHandler: ProgressBarHandler, private router: Router) {
    this.progressBarHandler.highlightSubject.subscribe(x => this.highlightNextStep = x);
  }

  public ngOnInit(): void {
    this.setFirstStepLabel();
  }

  private setFirstStepLabel(): void {
    if (this.router.url.includes(Constants.Routes.SKU_SEARCH)) {
      this.steps[0].title = 'Search results';
    } else {
      this.steps[0].title = 'Filter data';
    }
  }

}
